import { makeStyles } from '@fluentui/react-components';

import { workItemStateAccent } from './workItemColors';

export type WorkItemStateDotProps = {
    state: string;
};

// The ADO workflow state as a colour only — the state name lives in the
// tooltip, so it costs no width next to the work item id.
export const WorkItemStateDot: React.FC<WorkItemStateDotProps> = ({ state }) => {
    const classes = useStyles();
    const label = state.trim() === '' ? 'Unknown state' : state;
    return <span className={classes.dot} style={{ backgroundColor: workItemStateAccent(state) }} title={label} aria-label={label} />;
};

const useStyles = makeStyles({
    dot: {
        display: 'inline-block',
        width: '7px',
        height: '7px',
        borderRadius: '50%',
        flexShrink: 0,
    },
});
